import React from 'react';

import classes from './supportPage.module.css';

export function SupportPage() {
  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <svg className={classes.headerLogo} viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M149.971 299.943C232.798 299.943 299.943 232.798 299.943 149.971C299.943 67.1444 232.798 0 149.971 0C67.1444 0 0 67.1444 0 149.971C0 232.798 67.1444 299.943 149.971 299.943Z" fill="url(#rp-grad)" />
          <path fillRule="evenodd" clipRule="evenodd" d="M287.301 179.161C291.866 157.481 291.243 135.03 285.483 113.637C279.723 92.2433 268.989 72.514 254.156 56.0569C239.324 39.5998 220.812 26.8807 200.13 18.9364C179.448 10.9921 157.182 8.04756 135.146 10.3428C110.904 12.8058 87.7468 21.6483 68.0326 35.97C51.5113 47.8502 37.7692 63.1789 27.7577 80.895C17.7462 98.6111 11.7044 118.291 10.0507 138.573C8.39698 158.855 11.1708 179.254 18.1801 198.358C25.1894 217.462 36.2668 234.814 50.6453 249.214C65.0238 263.614 82.36 274.716 101.454 281.754C120.547 288.791 140.942 291.595 161.227 289.971C181.511 288.347 201.2 282.334 218.931 272.348C236.661 262.363 252.01 248.643 263.915 232.139C275.493 216.404 283.476 198.319 287.301 179.161ZM158.59 128.711L164.336 122.965C176.78 111.228 191.167 101.74 206.857 94.9242C199.166 110.152 188.924 123.951 176.575 135.721L170.829 141.467L158.59 128.711ZM147.098 278.855C140.831 278.655 134.589 277.983 128.423 276.843C82.4551 263.34 83.6043 224.325 116.931 193.698L122.677 199.444L121.586 244.838L149.052 218.349L149.856 185.769L178.586 158.36C201.091 136.967 218.728 110.982 230.3 82.1681L236.621 66.309L220.302 72.0551C191.135 82.1463 164.469 98.3694 142.099 119.632L113.369 147.213L80.444 146.466L52.6332 172.955L98.0268 174.047L103.773 179.793C75.5599 210.304 33.9587 212.948 22.8114 166.922C22.5172 165.712 22.306 164.483 22.1793 163.244C19.6103 140.709 23.1268 117.896 32.3631 97.1804C41.5993 76.4644 56.2179 58.6019 74.698 45.451C92.5867 32.3989 113.59 24.2749 135.606 21.8923C155.097 19.6746 174.838 21.9498 193.314 28.5434C211.79 35.137 228.511 45.8739 242.195 59.931L243.286 61.0802C254.999 73.2918 264.173 87.7052 270.278 103.486C276.384 119.267 279.298 136.102 278.854 153.017C278.444 169.956 274.7 186.648 267.835 202.139C260.969 217.631 251.118 231.617 238.844 243.298C226.571 254.98 212.115 264.128 196.303 270.219C180.492 276.31 163.634 279.225 146.696 278.797L147.098 278.855Z" fill="white" />
          <defs>
            <linearGradient id="rp-grad" x1="43.9571" y1="256.043" x2="256.043" y2="43.9571" gradientUnits="userSpaceOnUse">
              <stop stopColor="#6D00E6" />
              <stop offset="1" stopColor="#9601FF" />
            </linearGradient>
          </defs>
        </svg>
        <h1 className={classes.headerTitle}>RocketPlan Support</h1>
        <p className={classes.headerSubtitle}>
          Help center and product information for the RocketPlan platform
        </p>
      </header>

      <div className={classes.contactBar}>
        <div className={classes.contactBarInner}>
          <span className={classes.contactLabel}>Need help? Contact our support team:</span>
          <a href="mailto:support@rocketplantech.com" className={classes.contactEmail}>
            support@rocketplantech.com
          </a>
        </div>
      </div>

      <main className={classes.main}>
        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>What can RocketPlan do for you?</h2>
          <div className={classes.sectionBody}>
            <p>
              RocketPlan is an all-in-one project management solution for the restoration industry. The
              mobile app lets your company coordinate all job sites, engagements, and employees, while
              automatically uploading and organizing photos, IR photos, notes, hours reports, and more.
            </p>
            <p>
              With RocketPlan, you can keep all your information organized and available to everyone who
              needs it, no matter where they are, and avoid ever losing track of vital information along
              the way.
            </p>
            <p>
              RocketPlan can keep your company on track, from creating a new property to assessing damage
              to documenting work to submitting final documents. Save countless hours tracking projects,
              hunting down old photos, confirming memories, and filling simple paperwork.
            </p>
            <p>
              From building a team to taking photos to filling and submitting final paperwork, RocketPlan
              has a solution to save you time &ndash; and money.
            </p>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>Supported Territories</h2>
          <div className={classes.sectionBody}>
            <p>
              Currently, RocketPlan is available to customers in the United States, Canada, the United
              Kingdom, Australia, and New Zealand. We have plans to expand beyond these territories in the
              future, so please stay tuned!
            </p>
            <p>
              We&rsquo;d love to hear your feedback, and your vote for where to expand next! Let us know
              at{' '}
              <a href="mailto:support@rocketplantech.com">support@rocketplantech.com</a>
            </p>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>Types of Projects</h2>
          <div className={classes.sectionBody}>
            <p>
              On the RocketPlan platform, new projects fall into different categories depending on the
              nature of the property and some of its physical features. It&rsquo;s important to properly
              categorize each project, so RocketPlan can offer appropriate room types, save all necessary
              info, and correctly file all paperwork for prompt and proper payment.
            </p>
            <div className={classes.projectType}>
              <span className={classes.projectTypeLabel}>Residential Project</span> &ndash; Residential
              projects are those properties zoned as residential, whether owned or rented by the current
              inhabitant. Residential projects can have exterior spaces added as rooms, which is distinct
              for wholly outdoor projects, described below.
            </div>
            <div className={classes.projectType}>
              <span className={classes.projectTypeLabel}>Single Unit Residential</span> &ndash; Single
              Unit Residential properties, like houses, which have a single owner.
            </div>
            <div className={classes.projectType}>
              <span className={classes.projectTypeLabel}>Multi Unit Residential</span> &ndash; Multi Unit
              Residential properties, like apartment buildings, which have owners and/or renters in
              separate spaces.
            </div>
            <div className={classes.projectType}>
              <span className={classes.projectTypeLabel}>Exterior Project</span> &ndash; This category
              covers entirely outdoor properties, where the whole of the work area is exterior. To add
              singular exterior spaces that are part of indoor/outdoor properties, add a Single or Multi
              Unit Residential and add an exterior space as a room.
            </div>
            <div className={classes.projectType}>
              <span className={classes.projectTypeLabel}>Commercial Project</span> &ndash; Commercial
              projects have access to different room types, and final paperwork will be filled to reflect
              the project&rsquo;s commercial status.
            </div>
            <div className={classes.projectType}>
              <span className={classes.projectTypeLabel}>Single-Location</span> &ndash; Use the Single
              Location category to add a single unit within a larger property, when the rest of the
              property is not part of your company&rsquo;s portfolio.
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>Your Project Structure</h2>
          <div className={classes.sectionBody}>
            <p>
              On RocketPlan, the first thing your company does is build out its active project structure.
              This means creating a new Project for each active worksite, along with any vital information
              like address, property type, and more &mdash; remember, you only need to do this once! You
              create properties by address, units (if applicable) by number, levels (if applicable) by
              number, and rooms by type.
            </p>
            <p>
              Once you have built your project structure on RocketPlan, all work then occurs within it.
              Photos taken on-site are loaded directly into the correct room assignment and will remain
              easily retrievable, forever. All you need to do is keep adding new projects to RocketPlan as
              they come in, and you&rsquo;ll be automatically organized, and synced across all your
              employees.
            </p>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>Your Team Structure</h2>
          <div className={classes.sectionBody}>
            <p>
              Building your team on RocketPlan is as easy as sending an invite to each worker who will
              contribute to your projects. Once your invite has been accepted, a new team member will be
              instantly able to take photos for upload right in the field, using the app.
            </p>
            <p>
              Not everyone needs to see every scrap of information your company produces, so with
              RocketPlan you can assign key roles to each new team member you invite. This ensures that
              technicians and other on-site workers can avoid having their time wasted scrolling past
              extraneous information, while project managers and other decision makers can see everything
              they need to run their business.
            </p>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>What is the FLIR One IR Camera?</h2>
          <div className={classes.sectionBody}>
            <p>
              Teledyne&rsquo;s FLIR One is an iOS-compatible IR thermal imaging camera meant for
              ultra-compact IR photography, on the go. Its tiny size makes it perfect for technicians
              moving from site to site, making a worker&rsquo;s kit lighter, cheaper, and more convenient
              all at once.
            </p>
            <p>
              RocketPlan offers full integration with FLIR One imaging, meaning that IR images are just as
              easy to take, organize, and retrieve as any other type of photo. With FLIR One, RocketPlan
              makes water damage restoration far easier than ever before.
            </p>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>Create User or Company Account</h2>
          <div className={classes.sectionBody}>
            <p>
              Download the RocketPlan app through your iPhone&rsquo;s built-in App Store. Please note that
              RocketPlan is currently available on iOS and the desktop web interface.
            </p>
            <p>
              To begin, navigate to the RocketPlan homepage and enter your email address or securely log
              in with a social media account. You will be given the option to either &ldquo;Create a
              Company&rdquo; or &ldquo;Join a Company&rdquo;.
            </p>
            <p>
              To create a company, you must enter a password and your mobile number. Once you have verified
              your account by entering the 4-digit code sent to your mobile phone, you will then be asked
              to enter your first &amp; last name along with company name.
            </p>
            <p>
              To join a company, you will need an invite link from an existing company on RocketPlan. If
              they have already extended an invitation to your user email, you can see this invitation when
              you login.
            </p>
            <p>Congratulations, you are now a RocketPlan user!</p>
          </div>
        </div>

        <div className={classes.section}>
          <h2 className={classes.sectionTitle}>Technical Requirements</h2>
          <div className={classes.sectionBody}>
            <p>
              RocketPlan currently runs on desktop web browsers and via the iOS mobile app. The minimum
              device and software requirements to run RocketPlan are:
            </p>
            <div className={classes.requirementGroup}>
              <div className={classes.requirementGroupTitle}>iOS:</div>
              <ul className={classes.requirementList}>
                <li>Any iPhone model from the iPhone 5s</li>
                <li>Any iPad model from the iPad Air</li>
                <li>Any iPod model from the iPod Touch</li>
                <li>iOS 14 or newer</li>
                <li>IR image capture requires FLIR One camera for iPhone</li>
              </ul>
            </div>
            <div className={classes.requirementGroup}>
              <div className={classes.requirementGroupTitle}>Web:</div>
              <ul className={classes.requirementList}>
                <li>Google Chrome or Mozilla Firefox recommended for desktop web browser</li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <footer className={classes.footer}>
        <div className={classes.footerLinks}>
          <a href="mailto:support@rocketplantech.com" className={classes.footerLink}>
            Contact Support
          </a>
          <a href="https://www.rocketplantech.com/privacy-policy" className={classes.footerLink}>
            Privacy Policy
          </a>
          <a href="https://www.rocketplantech.com/terms-of-service" className={classes.footerLink}>
            Terms of Service
          </a>
        </div>
        <p className={classes.copyright}>
          &copy; {new Date().getFullYear()} RocketPlan Technologies Inc. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
